import React, { useState } from "react";

function Riddle() {
  const [answer, setAnswer] = useState("");
  const [feedback, setFeedback] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (answer.toLowerCase().trim() === "tomorrow") {
      setFeedback({ message: "🎉 Nailed it! Tomorrow is the answer. You're on fire! 🔥", type: "success" });
    } else {
      setFeedback({ message: "😅 Oops! Not quite. Give it another shot!", type: "danger" });
    }

    // Clear feedback after 5 seconds
    setTimeout(() => {
      setFeedback("");
    }, 6000);
  };

  return (
    <div className="riddle-section">
      <h2>Riddle Time!</h2>
      <p>
        I am always coming, but never arrive.<br />
        I am always near, but never here.<br />
        Everyone has me, but no one has seen me.<br />
        What am I?
      </p>
      <p className="text-muted"><em>Take your best guess — no pressure, just vibes! 😎</em></p>
      <form onSubmit={handleSubmit} className="mt-3">
        <div className="input-group mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Your answer"
            value={answer}
            onChange={(e) => setAnswer(e.target.value)}
          />
        </div>
        <button className="btn btn-primary mb-3" type="submit">
          Submit
        </button>
        {feedback && (
          <p className={`text-${feedback.type} d-flex align-items-center`}>
            {feedback.type === "success" ? (
              <span className="me-2">✅</span>
            ) : (
              <span className="me-2">❌</span>
            )}
            {feedback.message}
          </p>
        )}
      </form>
    </div>
  );
}

export default Riddle;
